import script from "./manualOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./manualOutput.vue?vue&type=script&setup=true&lang=ts"

import "./manualOutput.vue?vue&type=style&index=0&id=5e3c2af0&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3c2af0"]])

export default __exports__